module.exports = __webpack_public_path__ + "static/media/section3div3Main2img.651773b3.gif";